export default __webpack_public_path__ + "static/media/neo4j.a09637cd.png";